namespace JupitersChoice {
    export class StartBaseGameJupiterAnticipationCmd {

        execute(): void {
            // const response: any = this._server.logicResponse;
            // const spinInfo = this._stateModel.currentSubgame === 'FreeGame' ? response.freespins[ShowFreeGameCmd.currentFreeGameSpinIdx - 1] : response;
            // const lockedReels = this._responseHelper.getLockedReels(spinInfo.lockedWithPreviousReel);
            // var componentId = 'JupiterBaseGame';
            // var animIntro: string = 'antic_intro';
            // var animIdle: string = 'antic_idle';
            //
            // if (this._stateModel.currentSubgame === 'FreeGame') {
            //     componentId = this._orientationModel.isLandscape ? 'JupiterFreeGameLandscape' : 'JupiterFreeGamePortrait';
            // } else {
            //
            //     if(this._orientationModel.isPortrait){
            //         animIntro = 'portrait_antic2_intro';
            //         animIdle = 'portrait_antic2_idle';
            //     }
            // }
        }
    }
}